export default __webpack_public_path__ + "static/media/s2.459c9a69.png";